import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import './index.scss';

export default function GuidelinesLight({header, guidelines = []}) {
    function guideline({guideline, should}) {
        const classes = classNames('guidelines-light__row', {
            'guidelines-light__row--do': should,
            'guidelines-light__row--do-not': !should
        });
        return (
            <div key={guideline} className={classes}>
                {guideline}
            </div>
        );
    }

    return (
        <div className="guidelines-light">
            <div className="guidelines-light--header">{header}</div>
            {R.map(guideline, guidelines)}
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/guidelines_light/index.js